/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BillingAggregationRequest extends models.BillingAggregationBase {
    getFixupPrototypeFunction() { return BillingAggregationRequest.fixupPrototype; }

    static newInstance(model: Partial<BillingAggregationRequest>): BillingAggregationRequest {
        let obj = Object.assign(new BillingAggregationRequest(), model);
        BillingAggregationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BillingAggregationRequest>): BillingAggregationRequest {
        if (!model) return null;
        return BillingAggregationRequest.newInstance(<BillingAggregationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BillingAggregationRequest) {
        if (!obj) return;

        models.BillingAggregationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BillingAggregationRequest): boolean {
        if (models.BillingAggregationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BillingAggregationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.limit === undefined) {
            this.limit = 0;
        }
        if (this.group_by) {
            for (let val of this.group_by) {
                models.BillingGroupByDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Billing plan to select data from
     */
    billing_source: string;

    /**
     * If set, the dimensions to group results by
     */
    group_by: Array<models.BillingGroupByDetails>;

    /**
     * If set, limits the results to given number.
     */
    limit: number;

    /**
     * If set, results for cost data gets computed based on billing period start dates that falls in the range of the start date and end date.
     */
    billing_mode: boolean;

    /**
     * If set, intercept the query operators to manipulate platform specific accounts. This is only applicable for ServiceAccountQueryOperator manipulation when the visitor is platform and call made through billing plans.
     */
    include_resource_children: boolean;

}
